import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const NAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="NA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#093"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3195F9"
          fillRule="evenodd"
          d="M0 0v12L16 0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          stroke="#F7FCFF"
          d="m16.63-1.28 1.17 2.52.18.385-.352.239L.213 13.718l-.454.31-.265-.48-1.433-2.598-.223-.402.383-.255L15.9-1.485l.485-.323.245.528Z"
        />
        <Path
          fill="#FECA00"
          d="m3.919 1.623.964-.375-.376.963 1.023.157-.808.647.808.647-1.023.157.376.964-.964-.376L3.76 5.43l-.646-.807-.647.807-.157-1.023-.964.376.375-.964L.7 3.662l.808-.647L.7 2.368l1.022-.157-.375-.963.964.375L2.468.6l.647.808L3.761.6l.158 1.023Zm-.804.142a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0 .25a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
